module.exports = __webpack_public_path__ + "img/cheerful-woman.95e67d71.png";